export default class WidgetCode {
  static selectorString() {
    return '.WidgetCode';
  }

  render(node, props) {
    this.textarea = node.querySelector('[name="widgetCode"]');
    this.newTabCheckbox = node.querySelector('[name="openWidgetInNewTab"]');
    this.newTabCheckbox.addEventListener('change', this.updateTextareaValue.bind(this));
    this.updateTextareaValue();
  }

  updateTextareaValue() {
    this.textarea.value = this.newTabCheckbox.checked
      ? this.props.scriptNodeWithNewTab
      : this.props.scriptNode;
  }
}
